import actions from "./actions";

const state = () => ({
  renungan: null,
  loading: false
});

const mutations = {
  startGettingRenungan: state => {
    state.loading = true;
  },
  setRenungan: (state, renungan) => {
    state.loading = false;
    state.renungan = renungan;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
